import React, { useContext, useEffect, useState } from 'react';
// import BrandSick from '../Brand/BrandSick';
import { Box, CardContent, Grid, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
// import WhitePack from '../../src/assests/images/whitePack.svg';
// import BluePack from '../../src/assests/images/bluePack.svg';
import TagOrange from '../../src/assests/images/taggzOrange.svg';
import MarBol from '../../src/assests/images/morboCardImg.svg';
import WhitePack2 from '../../src/assests/images/whitePack2.svg';
import WhitePack3 from '../../src/assests/images/whitePack3.svg';
import WhitePack4 from '../../src/assests/images/whitePack4.svg';
import WhitePack5 from '../../src/assests/images/WhitePack5.svg';
import WhitePack6 from '../../src/assests/images/WhitePack6.svg';
import WhitePack7 from '../../src/assests/images/WhitePack7.svg';
// import WhitePack8 from '../../src/assests/images/WhitePack8.svg';
import WhitePack88 from '../../src/assests/images/whitePack88.svg';
import WhitePack9 from '../../src/assests/images/WhitePack9.svg';
import WhitePack10 from '../../src/assests/images/WhitePack10.svg';
import WhitePack11 from '../../src/assests/images/WhitePack11.svg';
import WhitePack12 from '../../src/assests/images/WhitePack12.svg';
import WhitePack13 from '../../src/assests/images/WhitePack13.svg';
import WhitePack14 from '../../src/assests/images/WhitePack14.svg';
import WhitePack15 from '../../src/assests/images/WhitePack15.svg';
import WhitePack16 from '../../src/assests/images/WhitePack16.svg';
import { getBannerDetails } from '../utils/apis';
import { AuthContext, AuthContextType } from '../context/AuthContext';
import { KEY_BILLINGCITY } from '../utils/contants';




const productData = [
    {
        imgSrc: MarBol,
        alt: 'White Pack',
        titles: ['Marlboro Red', '10s pack : ₹240*', '20s pack : ₹480*'],
    },
    {
        imgSrc: WhitePack2,
        alt: 'Blue Pack',
        titles: ['Marlboro Gold', '10s pack : ₹240*', '20s pack : ₹480*'],
    },
    {
        imgSrc: WhitePack3,
        alt: 'White Pack',

        titles: ['Marlboro Gold Advance', '10s pack : ₹240*', '20s pack : ₹480*'],
    },
    {
        imgSrc: WhitePack4,
        alt: 'White Pack',
        titles: ['Marlboro Fuse Beyond', '10s pack : ₹240*', '20s pack : ₹480*'],
    },
    {
        imgSrc: WhitePack5,
        alt: 'White Pack',
        titles: ['Marlboro Vista Forest Fusion', '20s pack : ₹480*'],
    },
    {
        imgSrc: WhitePack6,
        alt: 'White Pack',
        titles: ['Marlboro Clove Mix', '10s pack : ₹240*'],
    },
    // {
    //     imgSrc: WhitePack7,
    //     alt: 'White Pack',
    //     titles: ['Marlboro Vista Tropical Fusion', '10s pack : ₹170*'],
    // },
    {
        imgSrc: WhitePack88,
        alt: 'White Pack',
        newTag: 'New',
        titles: ['Marlboro Vista Double Fusion', '20s pack : ₹390*'],
    },
    {
        imgSrc: WhitePack9,
        alt: 'White Pack',
        titles: ['Marlboro Fine Touch', '10s pack : ₹195*'],
    },
    {
        imgSrc: WhitePack10,
        alt: 'White Pack',
        titles: ['Marlboro Filter Black', '12s pack : ₹270*'],
    },
    {
        imgSrc: WhitePack11,
        alt: 'White Pack',
        titles: ['Marlboro Advance Compact', '10s pack : ₹115*'],
    },
    // {
    //     imgSrc: WhitePack14,
    //     alt: 'White Pack',
    //     newTag: 'New',
    //     titles: ['Marlboro Vista Taaza Twist', '10s pack : ₹95*'],
    // },
    {
        imgSrc: WhitePack15,
        alt: 'White Pack',
        titles: ['Marlboro Advance Pocket', '10s pack : ₹85*'],
    },
    // {
    //     imgSrc: WhitePack16,
    //     alt: 'White Pack',
    //     titles: ['Marlboro Filter Black Kings', '10s pack : ₹150*'],
    // },

];

const Brand = () => {
    // const navigate = useNavigate();
    // const location = useLocation();
    const [bannerData, setBannerData] = useState<any>(null);
    const [brandData, setBrandData] = useState<any>(null);

    const authContext = useContext(AuthContext) as AuthContextType;


    useEffect(() => {
        const fetchData = async () => {
            if (!authContext?.token) {
                console.error('Token not available');
                return;
            }
            try {
                const location = localStorage.getItem(KEY_BILLINGCITY)
                const data = await getBannerDetails({ type: 'banners', locations: [location] }, authContext.token);
                console.log('location', location);
                console.log('Fetched banner data:', data);
                setBannerData(data);
            } catch (err) {
                console.error('Error fetching banner data:');
            }
        };
        const fetchData2 = async () => {
            if (!authContext?.token) {
                console.error('Token not available');
                return;
            }
            try {
                // const location = localStorage.getItem(KEY_BILLINGCITY)
                // // const data2 = await getBannerDetails({ type: 'brands', locations: [location] }, authContext.token);
                // // console.log('location', location);
                // // console.log('Fetched banner data:', data2);
                setBrandData({data:productData});
            } catch (err) {
                console.error('Error fetching banner data:');
            }
        };

        fetchData();
        fetchData2();
    }, [authContext?.token]);

    const bannerSlickdata = bannerData?.data
    console.log(bannerSlickdata, "bannerSlickdatasssssssssss")

    return (
        <>
            {/* <BrandSick bannerSlickdata={bannerSlickdata} /> */}
            <Box sx={{ padding: "0 20px 96px", cursor: "pointer" }} >
                <Grid container spacing={2}>
                    {brandData?.data.map((product: any, index: any) => (
                        <Grid item md={6} xs={6} key={index}>
                            <CardContent sx={{ background: "#FFFFFF", boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.05)", borderRadius: "12.5px", padding: "0", height: "100%" }}>
                                <Box sx={{ position: "relative" }}>
                                    <img
                                        src={`${product.imgSrc}`}
                                        alt={product.image_path}
                                        crossOrigin="anonymous"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            borderTopLeftRadius: "8px",
                                            borderTopRightRadius: "8px",
                                            maxWidth: "335px"
                                        }}
                                    />
                                    {product.newTag && (
                                        <Box sx={{ position: "absolute", top: "17px", right: "-3px" }}>
                                            <Box sx={{ position: "relative" }}>
                                                <img
                                                    src={TagOrange}
                                                    alt={'New'}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                    }}
                                                />
                                                <Typography sx={{ position: 'absolute', top: "47%", fontSize: "12px", fontWeight: "500", lineHeight: "120%", letterSpacing: "-0.6px", color: "#FFFFFF", transform: "translate(-50%, -50%)", left: "50%" }}>
                                                    {product.newTag}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                                {product.titles.map((title:any, i:any) => (
                                    <Typography
                                        key={i}
                                        sx={{ fontSize: "12px", fontWeight: "700", lineHeight: "20px", color: "#282829", marginBottom: "4px", padding: "0 10px" }}
                                    >
                                        {title}
                                    </Typography>
                                ))}

                                {/* <Typography
                                    sx={{ fontSize: "12px", fontWeight: "700", lineHeight: "20px", color: "#282829", marginBottom: "4px", padding: "0 10px" }}
                                >
                                    {product.brand_name}
                                </Typography>
                                <Typography
                                    sx={{ fontSize: "12px", fontWeight: "500", lineHeight: "18px", color: "#555555", marginBottom: "4px", padding: "0 10px" }}
                                >
                                    10s pack: ₹{product.tens_pack}
                                </Typography>
                                <Typography
                                    sx={{ fontSize: "12px", fontWeight: "500", lineHeight: "18px", color: "#555555", padding: "0 10px" }}
                                >
                                    20s pack: ₹{product.twentys_pack}
                                </Typography> */}
                            </CardContent>
                        </Grid>
                    ))}
                </Grid>

            </Box>
             {/* <Box sx={{position:"fixed",bottom:"0",background:"#FFF",padding:"16px",left:"0",right:"0",top:"auto"}}>  
                <Box sx={{borderRadius:"40px",border:"1px solid #F9E3B6",background:"#FBF3E0",padding:"8px 0"}}>
                    <Typography sx={{fontSize:"12px",fontWeight:"600",color:"#8C4B02"}} variant="subtitle1">*MRP inclusive of all taxes</Typography>
                </Box>
            </Box> */}
        </>
    );
};

export default Brand;
